import { mapActions, mapState } from 'vuex';
import TotalAmounts from './TotalAmounts';
import BetSlipRiskInput from './BetSlipRiskInput';
import BetSlipSelection from './BetSlipSelection';
import BetSlipTitle from './BetSlipTitle';
import {
  americanToDecimal,
  convertOdds,
  createBet,
  getTranslatedBetType,
  normalizeSpread,
  parseBetErrorMessage,
  roundAmount,
} from './bet-slip-utils';
import { isChecked } from '@/views/sports/components/bet-slip/check-bets';
import snq from 'snq';
import { modifyAmountInput } from '@/utils/common';

export default {
  data() {
    return {
      showCheckbox: false,
    };
  },
  components: {
    TotalAmounts,
    BetSlipRiskInput,
    BetSlipSelection,
    BetSlipTitle,
  },
  computed: {
    ...mapState({
      betOptionsResponse: state => state.betSlip.betOptionsResponse,
      selections: state => state.betSlip.selections,
      freeWagersViewing: state => state.freeWagerStore.freeWagersViewing,
      selectedLocale: state => state.settings.selectedLocale,
      activeFreeBet: state => state.betSlip.activeFreeBet,
      bets: state => state.betSlip.bets,
      terminalInfo: state => state.settings.terminalInfo,
      selectedType: (state) => state.betSlip.selectedType,
    }),
    getLocationMinBet() {
      return this.$store.getters['settings/getLocationMinBet'];
    },
  },
  methods: {
    americanToDecimal,
    roundAmount,
    createBet,
    parseBetErrorMessage,
    getTranslatedBetType,
    normalizeSpread,
    convertOdds,
    ...mapActions({
      createOrUpdateBet: 'betSlip/createOrUpdateBet',
      removeBetFromSlip: 'betSlip/removeBetFromSlip',
      removeBetFromSelections: 'betSlip/removeBetFromSelections',
      removeBetFromSlipByIndex: 'betSlip/removeBetFromSlipByIndex',
    }),
    getCheckedBetIds() {
      const checkedBetIdsFromState = this.bets
          .filter(b => b.checked)
          .map(b => b.betid)
          .toJSON();
      return checkedBetIdsFromState;
    },
    getCheckeds(list) {
      return list;
      // return list.filter(bet => this.getCheckedBetIds().includes(bet.bet.line_selections[0].selection_identifier));
    },
    getIfs() {
      return [this.betOptionsResponse];
      return this.betOptionsResponse.filter(bet => bet.bet.type === 'if_win' || bet.bet.type === 'if_win_or_tie');
    },
    getParlays() {
      return this.betOptionsResponse;
    },
    getCheckedParlays() {
      const parlays = this.getParlays();
      const checkeds = parlays.map(p => {
        return {
          ...p,
          bet: {
            ...p.bet,
            line_selections: p.bet.line_selections.filter(l => isChecked(l.selection_identifier)),
          },
        };
      });

      return checkeds;
    },
    getCheckedParlaysLineSelectionCount() {
      return snq(() => this.getCheckedParlays()[0].bet.line_selections.length);
    },
    getReverses() {
      return this.betOptionsResponse.filter(bet => bet.bet.type === 'reverse');
    },
    getRoundRobins() {
      return this.betOptionsResponse;
    },
    getCheckedRoundRobins() {
      const roundRobins = this.getRoundRobins();
      const checkeds = roundRobins.map(p => {
        return {
          ...p,
          bet: {
            ...p.bet,
            line_selections: p.bet.line_selections.filter(l => isChecked(l.selection_identifier)),
          },
        };
      });

      return checkeds;
    },
    getCheckedRRLineSelectionCount() {
      return snq(() => this.getCheckedRoundRobins()[0].bet.line_selections.length);
    },
    getStraights() {
      // if (this.betOptionsResponse.IdWagerType == 0)
      return this.betOptionsResponse;
    },
    getCheckedStraights() {
      return this.getCheckeds(this.getStraights());
    },
    getTeasers() {
      return this.betOptionsResponse;
    },
    getBetMinLimit(bet) {
      if (bet && bet.limits) return bet.limits.min_bet;
      return 0;
    },
    getBetMaxLimit(bet) {
      if (bet && bet.limits) return bet.limits.max_bet;
      return 0;
    },
    getMaxPayoutLimit(bet) {
      let options = this.betOptionsResponse;
      if (options && options.limits && !this.activeFreeBet) {
        return parseInt(options.limits.max_payout_amount) + parseInt(options.input_risk_amount);
      } else if (options && options.limits && this.activeFreeBet) {
        return parseInt(options.limits.max_payout_amount);
      }

      return 0;
    },
    fixWinAmount(bet, value) {
      // if (value > this.getMaxPayoutLimit(bet)) {
      //   return this.getMaxPayoutLimit(bet);
      // }

      return value;
    },
    isNumber: function (evt) {
      modifyAmountInput(evt);
    },

    maxErrorCondition(bet) {
      if (this.selectedType != 'straight')
        bet = this.betOptionsResponse;
      const limitType = this.getLimitType(this.betOptionsResponse);

      const input_risk_amount = this.$taxHelper.applyTaxToRiskInputHidden({
        input_risk_amount: bet.input_risk_amount,
      });

      const input_win_amount = bet.input_win_amount;

      if (!parseFloat(bet.input_risk_amount)) {
        return false;
      }

      const betMaxLimit = this.getBetMaxLimit(bet);

      switch (limitType) {
        case 0: // Default: Check both of win and risk amounts
          return (
              (input_risk_amount && input_risk_amount > betMaxLimit) ||
              (input_win_amount && input_win_amount - input_risk_amount > betMaxLimit)
          );
        case 2: // Risk: Check only risk amount
          return input_risk_amount && input_risk_amount > betMaxLimit;
        case 1: // Win: Check only win amount
          return input_win_amount - input_risk_amount > betMaxLimit;
      }
    },

    minErrorCondition(bet) {
      if (this.selectedType != 'straight')
        bet = this.betOptionsResponse;
      const limitType = this.getLimitType(this.betOptionsResponse);

      const input_risk_amount = this.$taxHelper.applyTaxToRiskInputHidden({
        input_risk_amount: bet.input_risk_amount,
      });

      const input_win_amount = bet.input_win_amount;

      if (!parseFloat(bet.input_risk_amount)) {
        return false;
      }

      const betMinLimit = this.getBetMinLimit(bet);

      // debugger;

      switch (limitType) {
        case 0: // Default: Check both of win and risk amounts
          return (
              (input_risk_amount && input_risk_amount < betMinLimit) ||
              (input_win_amount && input_win_amount - input_risk_amount < betMinLimit)
          );
        case 2: // Risk: Check only risk amount
          return input_risk_amount && input_risk_amount < betMinLimit;
        case 1: // Win: Check only win amount
          return input_win_amount - input_risk_amount  < betMinLimit;
      }
    },

    getRiskInputMinAmount(bet) {
      if (this.selectedType != 'straight')
        bet = this.betOptionsResponse;
      const limitType = this.getLimitType(this.betOptionsResponse);

      const input_risk_amount = this.$taxHelper.applyTaxToRiskInputHidden({
        input_risk_amount: bet.input_risk_amount,
      });

      const input_win_amount = bet.input_win_amount;
      return limitType === 'C' ? input_win_amount - input_risk_amount : this.getBetMinLimit(bet);
    },

    hasError(type, bet) {
      return this.minErrorCondition(bet) || this.maxErrorCondition(bet);
    },

    betSlipMinError(min, bet) {
      if (this.selectedType != 'straight')
        bet = this.betOptionsResponse;
      const limitType = this.getLimitType(this.betOptionsResponse);

      let text = '';

      switch (limitType) {
        case 0:
          text = this.$i18n.t('betslip.riskAndWinMinError').toString();
          break;

        case 2:
          text = this.$i18n.t('betslip.riskMinError').toString();
          break;

        case 1:
          text = this.$i18n.t('betslip.winMinError').toString();
          break;
      }

      text = text.replace('{currency}', this.terminalInfo.currency_name);
      text = text.replace('{min}', min);
      return text;
    },

    betSlipMaxError(max, bet) {
      if (this.selectedType != 'straight')
        bet = this.betOptionsResponse;
      const limitType = this.getLimitType(this.betOptionsResponse);

      let text = '';

      switch (limitType) {
        case 0:
          text = this.$i18n.t('betslip.riskAndWinMaxError').toString();
          break;

        case 2:
          text = this.$i18n.t('betslip.riskMaxError').toString();
          break;

        case 1:
          text = this.$i18n.t('betslip.winMaxError').toString();
          break;
      }

      text = text.replace('{currency}', this.terminalInfo.currency_name);
      text = text.replace('{max}', max);
      return text;
    },

    getLimitType(bet) {
      return snq(() => bet.limits.limit_type);
    },
    minBetConditionByBet(bet) {
      if (!this.$isElectron) {
        return false;
      }
      if (this.selectedType != 'straight')
        bet = this.betOptionsResponse;
      const input_risk_amount = this.$taxHelper.applyTaxToRiskInputHidden({
        input_risk_amount: bet.input_risk_amount,
      });

      if (!parseFloat(bet.input_risk_amount)) {
        return false;
      }

      return parseFloat(bet.input_risk_amount) < this.getLocationMinBet;
    },
    minBetConditionForRoundRobin(roundRobinTab) {
      if (!this.$isElectron) {
        return false;
      }
      let bet;
      if (this.selectedType != 'straight')
        bet = this.betOptionsResponse;
      let anyInputHasError = false;
      const roundRobinsAmounts = roundRobinTab.roundRobinsAmounts;
      const straightBetRiskAmount = roundRobinTab.straightBetRiskAmount;

      Object.values(roundRobinsAmounts)
          .filter(Boolean)
          .forEach(amount => {
            if (!!amount && parseFloat(amount) < this.getLocationMinBet) {
              anyInputHasError = true;
            }
          });

      if (straightBetRiskAmount && straightBetRiskAmount < this.getLocationMinBet) {
        anyInputHasError = true;
      }

      return anyInputHasError;
    },
    minBetConditionError(bet) {
      return this.$t('BetSlip.MinBetConditionError', [this.getLocationMinBet + ' ' + this.terminalInfo.currency_name]);
    },
  },
};
